import { SERVICE_TYPE } from '~/constant';
import { cleanObj } from '~/utils/object';
import { get, post, URLs } from './request';

const CartApi = {
  getDeliveryTimes,
  fetchCheckout,
  placeOrder,
};

export { CartApi };

/**
 * get a list of available delivery times from the back end
 * @param {object} props
 * @returns {Promise<any>}
 */
async function getDeliveryTimes({
  serviceType,
  deliveryGroupId,
  mealInstanceIds,
  startTime = 'asap',
}) {
  const query = cleanObj({
    delivery_group_id: deliveryGroupId,
    meal_instance_ids: mealInstanceIds,
    delivery_time: startTime,
  });
  const {
    data: { data },
  } = await get({
    url: `${baseUrl(serviceType)}/v3/delivery_times`,
    options: { CORS_API: true },
    data: {
      query,
    },
  });
  return data;
}

/**
 * Pass the checkout details inc. cart contents to the server and get back the totals.
 * @param {*} props
 */
async function fetchCheckout(props) {
  const {
    serviceType,
    meals,
    mealNotes,
    deliveryGroupId,
    addressId,
    deliveryDateTime,
    tips,
    checkoutMode,
    promoCode,
    note,
  } = props;
  const request = cleanObj({
    line_items: mealsToLineItems(meals, mealNotes),
    address_id: addressId,
    delivery_group_id: deliveryGroupId,
    delivery_datetime: deliveryDateTime,
    tips,
    checkout_mode: checkoutMode,
    promo_code: promoCode,
    note,
  });
  return post({
    url: `${baseUrl(serviceType)}/v4/orders`,
    options: { CORS_API: true },
    data: request,
  });
}

/**
 * Place the order
 * @param {object} props
 * @returns {Promise<any>}
 */
async function placeOrder(props) {
  const {
    serviceType,
    meals,
    mealNotes,
    deliveryGroupId,
    addressId,
    deliveryDateTime,
    tips,
    paymentMethodId,
    paymentNonce,
    paymentVendor,
    terminal,
    checkoutMode,
    promoCode,
    note,
  } = props;

  const request = cleanObj({
    line_items: mealsToLineItems(meals, mealNotes),
    address_id: addressId,
    delivery_group_id: deliveryGroupId,
    delivery_datetime: deliveryDateTime,
    tips,
    terminal,
    payment_method_id: paymentMethodId,
    payment_method_nonce: paymentNonce,
    payment_vendor: paymentVendor,
    checkout_mode: checkoutMode,
    promo_code: promoCode,
    note,
  });
  return post({
    url: `${baseUrl(serviceType)}/v4/orders`,
    options: { CORS_API: true },
    data: request,
  });
}

function mealsToLineItems(meals, mealNotes) {
  return meals
    .filter((meal) => meal.quantity > 0)
    .map((meal) => {
      const { id, quantity, customizationOptions } = meal;
      const item = {
        meal_instance_id: id,
        meal_instance_quantity: quantity,
        note: mealNotes[id] ? mealNotes[id] : null,
      };
      return {
        ...item,
        customized_options: Object.values(customizationOptions).map((option) => ({
          id: option.id,
          quantity: option.quantity,
        })),
      };
    });
}

const baseUrl = (serviceType) => {
  switch (serviceType) {
    case SERVICE_TYPE.PICKUP:
      return `${URLs.api}/pickup`;
    case SERVICE_TYPE.DINEIN:
      return `${URLs.api}/dine_in`;
    case SERVICE_TYPE.DELIVERY:
    default:
      return `${URLs.api}/on_demand`;
  }
};
